<template>
  <div id="HOME">
    <Header :logo ="logo"/>
    <!--<Todos v-bind:todos="todos" />-->
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-big
      rounded="sm"
      style="max-width: 100%;"

    >
    </b-overlay>
    <div class="testata">
      <b-embed  v-if="video"
        type="iframe"
        aspect="16by9"
        src="http://www.youtube.com/embed/LTseTg48568?autoplay=1&origin=http://example.com&frameborder=0"
        allowfullscreen
      >
      </b-embed>
      <b-carousel  v-if="!video"
        id="carousel-1"
        :interval="5000"
        fade
        controls
        indicators
        background="#ababab"

        style="text-shadow: 1px 1px 2px #333"
      >

        <b-carousel-slide
          class="firstCaro"
          v-for="(image,i) of preventivo.galleria_testata"
          v-bind:key="'gt-'+i"

          :img-src="`${image.src}`"
        >
          <h1 style="font-size:5em">{{valorizza_testo(preventivo.titolo,preventivo)}}</h1>
          <h2>{{valorizza_testo(preventivo.sottotitolo,preventivo)}}</h2>
        </b-carousel-slide>
      </b-carousel>
      
    </div>

    <div>
      <b-jumbotron id="back-color">
        <div class="paddingbox">
          <div class="row">
            <div
              class="col-sm-6"
              style="padding-top: 47px; color: grey; text-align: justify"
            >

                <p v-html="valorizza_testo(preventivo.testo_iniziale,preventivo)">

                </p>
                
            </div>
            <div class="col-sm-6">
                
              <section style="padding-top: 40px">
                <p  v-for="(item, index) in preventivo.slogan" :key="'sl-'+index" class="style" style>
                  <i v-if="item.icona" class="fa fa-tags" style="font-size:3em; color:green"></i>
                  <span style="font-size:1.3em;">{{item.titolo}}</span>
                  <br />{{item.sottotitolo}}
                </p>
              </section>
            </div>
          </div>
        </div>
      </b-jumbotron>
    </div>

    <div class="full-perposal">
      <!--<h1>{{ data1.id }}</h1>-->

      <b-container>
        <b-row align-h="around">
          <b-col :md="preventivo.soluzioni.length==1?5:4" v-for="data1 in preventivo.soluzioni" :key="'s2-'+data1.id">
            <div
              @click="activate(data1.id)"
              :class="{ border_new: active_el == data1.id, border_disabled: active_el != data1.id  }"
              style="max-width: 500px"
            >
              <div class="text-pp">
                <img
                  :src="`${data1.img}`"
                  alt="Not Found"
                  onerror="this.onerror=null;this.src='https://i.ibb.co/gj3Hr6v/placeholder.png';"
                  class="img-fluid w-100 d-block"
                />
                <div class="perposal-name">Soluzione {{ data1.id }}</div>
              </div>
              <div class="perposal-text">
                <div class="text-left">
                  <h3 class="font-weight-light subtitle-2">
                    ARRIVO / PARTENZA
                  </h3>
                  <h4 class="font-weight-bold subtitle-2">
                    {{ data1.dal }} / 
                    {{ data1.al }}
                  </h4>
                  <h3 class="font-weight-light subtitle-2">SISTEMAZIONE</h3>
                  <!--<h4>{{ data1.tipologie }}</h4>-->
                  
                  <h4 class="font-weight-bold">{{ cameresoluzione(data1) }}</h4>
                  <h3 class="font-weight-medium subtitle-2">
                    TRATTAMENTO
                  </h3>
                  <h4 class="font-weight-bold subtitle-2">
                      {{ data1.trattamento }}
                  </h4>
                  <h3 class="font-weight-medium subtitle-2">
                    PERSONE 
                  </h3>
                  <h4 class="font-weight-bold subtitle-2"  v-if="data1.eta_bambini_soluzione">
                    {{ data1.numero_adulti_soluzione }} Adulti <span v-if="data1.eta_bambini_soluzione && data1.eta_bambini_soluzione.length >0"> / {{data1.eta_bambini_soluzione.length}} Ridotti ({{data1.eta_bambini_soluzione.join(',')}} anni) </span>
                    
                  </h4>
                  <h4 class="font-weight-bold subtitle-2" v-if="!data1.eta_bambini_soluzione">
                     {{ data1.occupancy ? data1.occupancy.replace("Bambini", 'Ridotti'):"" }} 
                  </h4>
                   <div class="text-right"
                    
                  >

                  <div >
                      <!--<template v-for="(ris,r) in data1.risorse" >-->
                      <template v-for="(promo,p) in promo_soluzione(data1)" >
                        <i v-if="p==0" v-bind:key="promo.idpromozione+'-ico'+r" class="fa fa-2x fa-piggy-bank mr-1 pulse"  style="" aria-hidden="true"></i>
                        <span v-if="p>0" v-bind:key="promo.idpromozione+'-v'+r">, </span>
                        <span v-bind:key="promo.idpromozione+'-'+r">{{promo.Descrizione}}</span>
                      </template>
                    <!--</template>-->
                    <span class="testo-barrato ml-3" v-if="data1.prezzobar">€ {{ convertToTwoDecimals(data1.prezzobar) }}</span>
                    <span class="testo-barrato ml-3" v-else-if="data1.importo_standard_soluzione_notassa !=0 && Number(data1.importo_standard_soluzione_notassa) > Number(data1.totale_soluzione_notassa) && data1.importo_standard_soluzione_notassa">€ {{ convertToTwoDecimals(data1.importo_standard_soluzione_notassa / 100) }}</span>

                  </div>  

                   <h2 v-if="data1.prezzopers" class="text-uppercase headline font-weight-bold text-right sizebox">€ {{ convertToTwoDecimals(data1.prezzopers) }}</h2>
                   <h2 v-else class="text-uppercase headline font-weight-bold text-right sizebox">€ {{ convertToTwoDecimals(data1.totale_soluzione_notassa/100) }}</h2>
                   
                   <h6 v-if="data1.imposta_soggiorno_soluzione>0 && !preventivo.citytax_inclusa">city tax: € {{convertToTwoDecimals(data1.imposta_soggiorno_soluzione/100)}}</h6>
                  </div>
             

                  

                  <div
                    class="align-items-center d-flex font-weight-bold headline justify-content-between mt-4 text-uppercase"
                  >
                    <b-link
                      class="btn btn-lg btn-outline-warning"
                      id="confirm2"
                      @click="
                        activate(data1.id);
                        selected = `${data1.id}`;
                      "
                      :class="{ active: active_el == data1.id }"
                      v-on:click="(show = `foo-${data1.id}`), scrollMethod(`sol-${data1.id}`)"
                      >Dettagli</b-link
                    >

                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div class="tabsbv mt-5">
      <StickyElement  v-if="preventivo.soluzioni.length >1" visibleOnDirection="down" class="heightnnav" id="stickyel">
        <div>
          <div class="container pt-0" >
            <ul>
              <li 
                v-for="data1 in preventivo.soluzioni"
                :key="'s1-'+data1.id"
                @click="(selected = `${data1.id}`), activate(data1.id)"
                :class="{ active: selected === `${data1.id}` }"
                v-on:click="(show = `foo-${data1.id}`), scrollMethod(`sol-${data1.id}`)"
              >
                Soluzione {{ data1.id }}
              </li>
            </ul>
          </div>
        </div>
      </StickyElement>
      <b-container>
        
        <div
          class="proposal-new-box"
          v-for="data1 in preventivo.soluzioni"
          :key="'s4-'+data1.id"
          
        >
        <!-- Segnalino -->
        <div :id="`sol-${data1.id}`" style="height:10px" class="segnalino"></div>
          <b-card no-body class="mb-1" >
            <b-card-header header-tag="header" id="accord-heading" role="tab">
              <div
                @click="(selected = `${data1.id}`), activate(data1.id)"
                v-on:click="show = `foo-${data1.id}`"
                style="
                  text-align: left;
                  background: transparent;
                  border: none;
                  font-size: 22px;
                  padding:8px;
                "
                variant="light"
                
                block
              >
                Soluzione {{ data1.id }} - {{ data1.descrizione }}
                <i class="fa fa-angle-down right-icon" aria-hidden="true"></i>
              </div>
            </b-card-header>
            
            <b-collapse
              
              accordian="acc1"
              role="tabpanel"
              visible
              :v-model="true"
            >
              <b-card-body v-if="show == `foo-${data1.id}`">
                <div >
                  <div class="persoal-cc">
                    <h6>Soluzione soggiorno n. {{data1.id}} nel dettaglio</h6>
                    
                    <h3 v-if="data1.prezzopers">€ {{ convertToTwoDecimals(data1.prezzopers) }}</h3>
                    <h3 v-else>€ {{ convertToTwoDecimals(data1.totale_soluzione_notassa/100) }}</h3>
                  </div>
                  <div v-if="data1.annotazioni">
                    <p>{{ data1.annotazioni }}</p>
                  </div>

                  <div class="sliderbanner">
                    <div class="column pl-3" >
                      <div v-for="(risorsa) in data1.risorse" :key="'r1-'+risorsa.IdRisorsa" class="row">
                         <div>
                          <h2 v-if="data1.risorse.length >0">{{risorsa.Categoria}} - {{risorsa.DescrizioneTipologia}}</h2>
                          <h3 v-if="data1.risorse.length >0 && risorsa.Allestimento">{{risorsa.Allestimento}} </h3>
                          
                        <p class="desccam" v-for="info in risorsa.info" :key="'i1-'+info.id"
                          v-html="info.testo"
                          style="text-align: left"
                        ></p>
                      </div>
                      </div>
                    </div>
                      
                    <div class="dettcamera">
                    
                      <b-carousel
                        :id="`${data1.id}`"
                        v-model="slide"
                        :interval="4000"
                        controls
                        indicators
                        background="#ababab"
                        img-width="1024"
                        img-height="480"
                        style="text-shadow: 1px 1px 2px #333"
                      >
                        <!-- Text slides with image -->
                        <b-carousel-slide
                          v-for="(data,k) of data1.galleria"
                          v-bind:key="'gr3-'+data.id+'-'+k"
                          :img-src="`${data.src}`"
                        ></b-carousel-slide>
                      </b-carousel>
                    </div>



                    <div v-if="!data1.prezzopers && !data1.prezzobar" v-b-toggle.collapse-de class="detailsv mt-2">
                      <i class="fa fa-plus"></i> Dettaglio Prezzi
                    </div>

                    <b-collapse v-if="!data1.prezzopers && !data1.prezzobar"  id="collapse-de" class="mt-2">
                      <div class="destailsdd">
                        <div class="row border-box">
                          <div class="text-left body-1 font-weight-bold col">
                            Descrizione
                          </div>
                          <div
                            class="text-right text-uppercase body-1 font-weight-bold col"
                          >
                            PREZZO
                          </div>
                        </div>
                        <template v-for="(risorsa,i) in data1.risorse" >
                        <div class="row border-box" style="font-weight:300" v-bind:key="'rc-'+i">{{risorsa.Categoria}} - {{risorsa.DescrizioneTipologia}}
                          <template v-for="(promo,pc) in risorsa.ElencoPromozioni">
                            <i v-bind:key="'i'+pc"  class="fa fa-piggy-bank mr-1 pulse ml-3"  style="" aria-hidden="true"></i>
                            
                            <span v-bind:key="'a'+pc" color="green">{{promo.Descrizione}}</span>
                            <span v-bind:key="'v'+pc" v-if="pc > 0">,</span>
                          </template>
                        </div>
                        <div class="row" v-bind:key="'rsogg-'+i"  v-if="risorsa.extra.length>0"><b-icon icon="moon"></b-icon>Soggiorno</div>
                        <template v-for="(prezzi,k) in risorsa.prezzi">
                          <div
                            class="row border-box"
                            v-bind:key="'rr-'+k+risorsa.IdRisorsa"
                            v-if="Number(prezzi.importostd)!=0 ||Number(prezzi.importo)!=0  "
                          >
                            <div class="text-left body-1 font-weight-light col" 
                              >
                              {{ prezzi.descrizione }}
                              <span v-if = "prezzi.annotazioni"  style="font-size:0.8em">({{ prezzi.annotazioni}})</span>
                              <!-- SUITE - BB from 12/30/2020 to 12/31/2020 -->
                              <div></div>
                            </div>
                            <div class="text-right text-uppercase body-1 col">
                              <span class="testo-barrato" style="font-size:0.7em" v-if="Number(prezzi.importostd) > Number(prezzi.importo) && prezzi.importostd!=0" >€ {{ convertToTwoDecimals(prezzi.importostd/100) }}</span>  € {{ convertToTwoDecimals(prezzi.importo/100) }}
                            </div>
                          </div>
                        </template>
                        <div class="row" v-bind:key="'rextras-'+i" v-if="risorsa.extra.length>0" ><b-icon icon="collection"></b-icon>Extra</div>
                        <template v-for="(extra,k) in risorsa.extra">
                          <div
                            class="row border-box"
                            v-bind:key="'rr-'+k+risorsa.IdRisorsa"
                          >
                            <div class="text-left body-1 font-weight-light col" 
                              >
                             {{ extra.quantita }} x {{ extra.descrizione }}
                              <!-- SUITE - BB from 12/30/2020 to 12/31/2020 -->
                              <div></div>
                            </div>
                            <div class="text-right text-uppercase body-1 col">
                              <span  >€ {{ convertToTwoDecimals(extra.totale/100) }}</span> 
                            </div>
                          </div>
                        </template>
                        </template>
                      </div>
 
                    </b-collapse>


                    <!--<div class="row mt-3">
                      <div
                        class="text-left headline font-weight-light col font-32"
                      >
                        Totale
                      </div>
                      <div
                        class="text-right text-uppercase headline font-weight-bold col font-32"
                      >
                        € {{ data1.prezzo / 100 }}
                      </div>
                    </div>
                    -->
                  </div>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
          <div>
          <b-jumbotron id="back-color">
            <!-- <template #header>BootstrapVue</template> -->

            <table class="table">
              <th style="width: 72% !important; border-right: 1px solid #ccc">Descrizione</th>
              <th style="text-align: right">Totale</th>
              <tbody>
                <tr>
                <td >{{ data1.occupancy?data1.occupancy.replace("Bambini", 'Ridotti'):"" }} ({{ data1.dal }}-{{ data1.al }})
                    {{ data1.trattamento }}</td>
                <td  class="text-right col">
                    <h2 class="testo-barrato" v-if="data1.prezzobar">€ {{ convertToTwoDecimals(data1.prezzobar) }}</h2>
                    <h2 class="testo-barrato" v-else-if="Number(data1.importo_standard_soluzione_notassa) > Number(data1.totale_soluzione_notassa) && data1.importo_standard_soluzione_notassa!=0">€ {{ convertToTwoDecimals(data1.importo_standard_soluzione_notassa / 100) }}</h2>
                    
                    <h2 v-if="data1.prezzopers">€ {{ convertToTwoDecimals(data1.prezzopers) }}</h2>
                    <h2 v-else>€ {{ convertToTwoDecimals(data1.totale_soluzione_notassa / 100) }}</h2>

                </td>
                </tr>
                <tr v-if="data1.imposta_soggiorno_soluzione>0 && !preventivo.citytax_inclusa">
                <td >Imposta di soggiorno</td>
                <td  class="text-right col">
                                             <h4>€ {{ convertToTwoDecimals(data1.imposta_soggiorno_soluzione / 100) }}</h4>
                </td>
                </tr>
                <tr>
                  <td colspan="2" class="text-center col">

<!--@click="conferma_soluzione(data1)"-->
                    
                    <b-link  v-if="!is_scaduto && !antprimahr"
                          id="show-btn"
                          @click="conferma_click(data1)"
                          
                          class="btn btn-lg btn-success"
                          >Conferma</b-link
                      >

                  </td>
                  </tr>



              </tbody>
            </table>
          </b-jumbotron>
        </div>
        </div>
      </b-container>
    </div>

    <div
      class="container"
    >
      <!-- <p style="text-align: right; margin-right: 2%">
        dal {{ data.dal }} al {{ data.al }} per {{ data.occupancy }}
        {{ data.risorse[0].Trattamento.Descrizione }}
      </p>-->

      <div class="accordion" role="tablist">

        <!--<b-card no-body class="mb-1" v-for="(info,z) in preventivo.info.sort((a,b)=>(a.indice>b.indice)?1:-1)" :key="'pi-'+z"> -->
        <b-card no-body class="mb-1" v-for="(info,z) in preventivo.info" :key="'pi-'+z">
          <b-card-header
            header-tag="header"
            id="accord-heading"
            class="p-1"
            role="tab"
          >
            <b-button
              style="
                text-align: left;
                background: transparent;
                border: none;
                color: black;
                font-weight: bold;
              "
              block
              v-b-toggle="'accordion-'+z"
              variant="info"
            >
              {{ info.titolo }}
              <i aria-hidden="true" class="fa fa-angle-down right-icon"></i>
            </b-button>
          </b-card-header>
          <b-collapse
            :id="'accordion-'+z"
            visible
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card-text style="text-align: left">
                <div v-if="info.testo" v-html="`${info.testo.slice()}`"></div>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

      </div>

      <div class="container-fluid cont" >
        <div class="row" >
          <!--
          <div class="col-md-3" style="text-align: -webkit-left">
            <img
              src="https://via.placeholder.com/150"
              alt="trip-advisor"
            />
          </div>
          <div class="col-md-3" style="text-align: -webkit-left">
            <img
              src="https://via.placeholder.com/150"
            />
          </div>
          <div class="col-md-2"></div>
          -->
          <div class="col-md-12  my-auto" style="text-align: center">
            <p style="padding: 18px; background: #911; color: white" v-if="preventivo.data_opzione && is_scaduto ">
              Questa offerta non è
              <br />più disponibile
            </p>
            <p style="font-size: 18px; background: #141; color: white; padding:20px"  v-if="preventivo.data_opzione && !is_scaduto">
              Questa offerta è valida secondo disponibilità fino al {{convertidata(preventivo.data_opzione)}}.  
            </p>
            <div style="font-size: 18px; background: #141; color: white; padding:20px"  v-if="preventivo.data_opzione && !is_scaduto">
              Restano  <count-down :countDownDate ="preventivo.data_opzione"/> per confermare l'offerta.  
            </div>
            
          </div>
        </div>
      </div>
    </div>

    <!-- container ends here -->

    <div class="container-fluid contai" style="padding-left: 112px;">
      <div class="row">
        <div class="col-md-7">
          <h1 style="font-family: -webkit-pictograph; font-size: 32px">
            DOMANDE SULL'OFFERTA?
          </h1>
          <p style="color: grey; font-size: 15px">
            Servono informazioni aggiuntive? Non esiti a contattarci!
          </p>
        </div>
        <div class="col-md-3">
        
          <p style="text-align: -webkit-right; color: dimgrey">
            Il Suo interlocutore
            <br />{{preventivo.utente_nome}}
          </p>
          <!--
          <div
            class="cont"
            style="
              text-align: -webkit-right;
              background: #c3b89e;
              padding: 10px;
              position: relative;
              left: 59px;
            "
          >
          
            <a class="button2 btncontact" style="color: white"
              >Ci contatti nel messenger</a
            >
            
          </div>
          -->
        </div>

        <div class="col-md-2" style="text-align: center; padding-top: 0px; height:100px">
          <b-avatar :src="utente_immagine" size="6rem"></b-avatar>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-3" style="padding-right: 0px; padding-left: 0px">
              <b-img
                class="imgcover"
                :src="get_img_piede(0)"
                style="width: 100%"
                height="150px"
              ></b-img>
              <b-img
                class="imgcover"
                :src="get_img_piede(1)"
                height="150px"
                style="width: 100%"
              ></b-img>
            </div>
            <div class="col-md-3" style="padding-right: 0px; padding-left: 0px">
              <b-img
                class="imgcover"
                :src="get_img_piede(2)"
                style="width: 100%"
                height="150px"
              ></b-img>
              <b-img
               class="imgcover"
                :src="get_img_piede(3)"
                style="width: 100%"
                height="150px"
              ></b-img>
            </div>

            <div class="col-md-6" style="padding-right: 0px; padding-left: 0px">
              <b-img
                class="imgcover"
                :src="get_img_piede(4)"
                style="width: 100%"
                 height="300px"
              ></b-img>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-6" style="padding-right: 0px; padding-left: 0px">
              <b-img
                class="imgcover"
                :src="get_img_piede(5)"
                style="width: 100%"
                height="300px"
              ></b-img>
            </div>
            <div class="col-md-6" style="padding-right: 0px; padding-left: 0px">
              <b-img
                class="imgcover"
                :src="get_img_piede(6)"
                style="width: 100%"
                height="300px"
              ></b-img>
            </div>




          </div>
        </div>
        

      </div>
    </div>

    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-8" style="padding-left: 0px; padding-right: 0px">
          <iframe
            width="100%"
            height="350"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            :src="'https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q='+nomestruttura+' '+indirizzo+';t=&amp;z=18&amp;ie=UTF8&amp;iwloc=B&amp;output=embed'"
          ></iframe>
          </div>
        <div class="col-sm-4 bg-cont" style="padding-left: 55px">
          <h1 class="contatto">CONTATTO</h1>
          <i class="fa fa-map-marker" style="color: grey"></i>&nbsp; &nbsp;
          <span>{{indirizzo}}</span>
          <br />
          <i class="fa fa-phone" style="color: grey; padding-top: 8px"></i
          >&nbsp;&nbsp;
          <span>{{telefono}}</span>
          <br />
          <i class="fa fa-envelope" style="color: grey; padding-top: 8px"></i
          >&nbsp; &nbsp;
          <span><a :href="'mailto:'+mail">{{mail}}</a></span>
          <br />
          <i class="fa fa-globe" style="color: grey; padding-top: 8px"></i
          >&nbsp; &nbsp;
          <span><a :href="preventivo.url_sito">{{preventivo.url_sito}}</a></span>
          <br />
          <i v-if="preventivo.whatsapp" class="fa fa-whatsapp" style="color: grey; padding-top: 8px"></i
          >&nbsp; &nbsp;
          <span><a :href="'https://wa.me/'+preventivo.whatsapp">{{preventivo.whatsapp}}</a></span>
        </div>
      </div>
    </div>
    <div>
      <h1 class="text-center nostri">Follow Us</h1>
      <!-- <p style="font-weight:none;">I NOSTRI PARTNER</p> -->
    </div>



    <div class="container">
      <div class="row">
        <div class="col-md-12 col-md-offset-4 set">
          <ul class="iconsocial">
            <li>
              <b-link :href="preventivo.tripadvisor" v-if="preventivo.tripadvisor">
                <i class="fa fa-tripadvisor" style="color: grey; font-size:3em"></i>

              </b-link>
            </li>
            <li>
              <b-link :href="preventivo.facebook" v-if="preventivo.facebook">
                <i class="fa fa-facebook" style="color: grey; font-size:3em"></i>
              </b-link>
            </li>
            <li>
              <b-link :href="preventivo.instagram" v-if="preventivo.instagram">
                <i class="fa fa-instagram" style="color: grey; font-size:3em"></i>
              </b-link>
            </li>
            <li>
              <b-link :href="preventivo.pinterest" v-if="preventivo.pinterest">
                <i class="fa fa-pinterest" style="color: grey; font-size:3em"></i>
              </b-link>
            </li>
            <li>
              <b-link :href="preventivo.twitter" v-if="preventivo.twitter">
                <i class="fa fa-twitter" style="color: grey; font-size:3em"></i>
              </b-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <footer>
      <div class="bordertop text-center pt-2 pb-2">
        <div class="links">
          <span class="small" style="color: gray"
            >© {{nomestruttura}}</span
          >
          &nbsp; &nbsp;
          <span class="small" style="padding-left: 23px; color: gray"
            >Part. IVA {{piva}}</span
          >
          &nbsp;
          <span
            class="small"
            style="padding-left: 23px; font-size: 18px; color: gray"
          >
            <a
              class="footerlink small default"
              :href="preventivo.privacy_link"
              target="_blank"
              >Informativa sulla privacy</a
            >
          </span>

<!--
          <span
            class="offer-pdf small"
            style="padding-left: 23px; font-size: 18px; color: gray"
          >
            <a
              class="footerlink small default"
              href=""
              target="_blank"
              style="color: gray"
              >stampa</a
            >
          </span>
          -->
          <div class="clear">&nbsp;</div>
        </div>

        <div class="clear">&nbsp;</div>
      </div>

    </footer>

    <b-modal id="bv-modal-example" hide-footer hide-header centered>
      <div class="d-block text-center pt-5 pb-5">
        <h1>Grazie!</h1>
        <h2>Riceverai a breve le indicazioni per perfezionare la prenotazione.</h2>
      </div>
    </b-modal>

    <b-modal id="bv-modal-annotazioni" hide-footer hide-header centered>
      <div class="d-block  pt-1 pb-5">
        <h4 class="alert-heading">  <b-avatar :src="utente_immagine" ></b-avatar></h4>
        <hr>
          <p>
            {{this.preventivo.annotazioni}}
          </p>
        
      </div>
    </b-modal>

  <b-modal
  hide-header hide-footer centered
      v-model="dialog_conferma"
      width="500"
    >
      <div >
        <h1 class="d-block text-center pt-2 pb-2">Conferma Soluzione</h1>
        <v-divider></v-divider>
        <h4>          
          Clicca su Conferma per accettare la proposta, verrai ricontattato per perfezionare la prenotazione.
          Grazie.
          </h4>
      </div>

        <div class="row">
          <div class="col-md-3 ">
           <b-button class="btn btn-lg btn-success"  @click="confermasoluzione">Conferma</b-button>
          </div>

          <div class="col-md-5  ">
          </div>
          <div class="col-md-3  ">
            <b-button class="btn btn-lg btn-danger"  block @click="dialog_conferma=false">Indietro</b-button>
          </div>
        </div>
    </b-modal>
  </div>



</template>


<!-- v-on:del-todo="deleteTodo" -->
<script>
import CountDown from "@/components/CountDown.vue";
//import Soluzione from "@/components/Soluzione.vue";
import Editor from "@/components/Editor.vue";
//import EditorGalleria from "@/components/EditorGalleria.vue";
//import EditorEmail from "@/components/EditorEmail.vue";
//import SceltaTemplate from "@/components/SceltaTemplate.vue";
import VueFbCustomerChat from "vue-fb-customer-chat";
import Vue from "vue";
import { mapGetters } from "vuex";
// import Todos from "../components/Todos";
//import json from "../assets/proposal.json";
import Header from "../components/layout/header";
//import axios from "axios";
import StickyElement from "vue-sticky-element";

import Pusher from 'pusher-js' // import Pusher
import { ToastPlugin } from 'bootstrap-vue'
Vue.use(ToastPlugin)

export default {
  components: {
    //Soluzione,
    //Editor,
    //EditorGalleria,
    //SceltaTemplate,
    //EditorEmail,
    StickyElement,
    //Todos,
    Header,
    CountDown
  },
  name: "Preventivo",
  props: ["idreservation"],
  methods: {
    valorizza_testo(testo, preventivo){
      var r = testo || "";
      if(preventivo){
        r = r.replace("{Nominativo}",preventivo.nominativo);
        r = r.replace("{Arrivo}",preventivo.arrivo);
        r = r.replace("{Partenza}",preventivo.Partenza);
      }

      return r;
    },
     convertToTwoDecimals(input) {
      // Converte l'input in numero
      let num = parseFloat(input);

      // Verifica che il valore sia un numero valido
      if (isNaN(num)) {
        return NaN; // Se l'input non è un numero valido, restituisce NaN
      }

      // Ritorna il numero con 2 decimali
      return num.toFixed(2);
    },
    placeClick(marker) {
      console.log("this marker was clicked", marker);
    },
    cameresoluzione(soluzione) {
      let retv =""
      for (const key in soluzione.risorse) {
        if (Object.hasOwnProperty.call(soluzione.risorse, key)) {
            const r = soluzione.risorse[key];
            if(key > 0){
             retv +=' + '
            }
            retv += (r.Categoria||'')+' '+r.DescrizioneTipologia  
        }
      }
      return retv
    },
    gotonextpage() {
      console.log("hello");
      this.$router.push({ path: "/thankyou" });
    },
    activate: function (el) {
      console.log("el", el);
      this.active_el = el;
    },
    scrollMethod(id) {
      console.log("scrolls", id, this.show);

        let segnalini = document.getElementsByClassName("segnalino");
        segnalini.forEach(ele => {
            ele.style.height ="10px"
        });
        const el =  document.getElementById(id);
        const stel =  document.getElementById("stickyel");
        el.style.height=stel.clientHeight+"px";
        //segnalini[0].style.height ="10px";// il primo non lo aumento

      console.log("scrolls", id, this.show,el,el.style.height);
      setTimeout(()=>{
        el.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });


      },300)

      
    },
    //--------------------------------------------
    SetTempateData() {
      //this.template_to_export = presente
      console.log(this.template_to_export);
    },

    caricatesti() {
      this.$store.dispatch("getTesti", "cli1").then(
        response => {
          console.log(response);
          this.testiagg = response.data;
        },
        error => {
          console.error(error);
        }
      );
    },
    salvatemplate() {
      this.$router.push({ path: "/admin/saveastemplate#" });
    },
    applytemplate() {
      this.sceglitemplate = !this.sceglitemplate;
    },
    invia() {
      alert("da inviare!");
    },
    add_text(item) {
      this.$store.dispatch("addTesto", item).then(
        response => {
          console.log(response);
        },
        error => {
          console.error(error);
        }
      );
    },
    del_text(item) {
      this.$store.dispatch("delTesto", item).then(
        response => {
          console.log(response);
        },
        error => {
          console.error(error);
        }
      );
    },
    seleziona(soluzione) {
      this.tab = `tab-${soluzione.id}`;
      console.log(this.tab);
    },

    conferma_click(soluzione){
      this.soluzione_da_confermare  = soluzione
      this.dialog_conferma = true;
    },
    confermasoluzione() { 
      console.log("CONFERMO PREV",this.soluzione_da_confermare.comando_accettazione)  
      /*   
    this.$axios
      .get(soluzione.comando_accettazione)
      .then(res => {console.log(res); this.$bvModal.show('bv-modal-example')})
      .catch(err => console.log(err));
      */
      
      const occ = {
        Comando: "AccettaSoluzionePreventivo",
        NumeroSoluzione: this.soluzione_da_confermare.id,
        GUIDPrenotazione:this.idreservation
      };
      this.$store.dispatch("APIRequestHR", occ).then(r=>{
          console.log("RISP",r)
          if(r.data.RISPOSTAOK==-1){
            this.dialog_conferma = false
            this.$bvModal.show('bv-modal-example')
          }
          
      })
    },
    carica_preventivo(idpreve) {
      this.loading = true;
      var thisp =this;
      console.log("CARICO PRENVENTIVO", this.idreservation);
      const t = this.$route.query.t;

      //const con_pusher = false;

      this.$store
        .dispatch("getPreventivoMob", { idpreventivo: idpreve, template: t })
        .then(
          response => {
            console.log("LOG CARICO PRENVENTIVO", response);
            
              bodyStyles.setProperty('--secondary-color', response.data.colore_secondario);
              bodyStyles.setProperty('--primary-color', response.data.colore_principale);

              this.mail =response.data.mail;
              this.piva =response.data.piva;
              this.telefono =response.data.telefono;
              this.indirizzo = response.data.indirizzo;
              this.nomestruttura =response.data.nome_struttura;
              this.utente_immagine = response.data.utente_immagine;
              this.preventivo = response.data;
              if(response.data.immagini_generali && response.data.immagini_generali.length > 0){
                this.logo = response.data.immagini_generali[0].src;
              }
              document.title = 'Preventivo '+this.nomestruttura;
              
              const con_pusher = false;
              if(con_pusher){

                var pusher = new Pusher('e0bd97b4d791d4ce6f9d', {
                  authEndpoint: 'https://us-central1-hotel-runner-276212.cloudfunctions.net/PusherAuth',
                  cluster: 'eu',
                    auth: {
                      params: { 
                        guids: response.data.guidstrutturahr,
                        struttura: this.nomestruttura,
                        p: this.preventivo.id,
                        name: this.preventivo.nominativo},
                      headers: { baz: 'boo' }
                    }
                });

                              //var guidstruttura = response.data.guidstrutturahr.replaceAll("-","-");
              var pres_general_channel = pusher.subscribe('presence-channel');
              pres_general_channel.bind('my-event', function(data) {
                alert(JSON.stringify(data));
              });
              var pres_channel = pusher.subscribe('private-minisito.'+this.preventivo.id);
              pres_channel.bind('my-event', function(data) {
                    thisp.$bvToast.toast(`${data}`, {
                    title: 'Messaggio',
                    autoHideDelay: 5000,
                    appendToast: true
                  })
              });
              
              //var channel = pusher.subscribe('minisito.'+guidstruttura);
              var channel = pusher.subscribe('private-channel-2');       
              channel.bind('node-event', function(data) {
                alert(data);
              });

              }






              if(this.preventivo.annotazioni){
               setTimeout(()=>{
                this.$bvModal.show('bv-modal-annotazioni')
               },5000)
                
              }
              this.loading = false;
          },
          error => {
            console.error(error);
          }
        );
      let bodyStyles = document.body.style;
      
    },
      promo_soluzione(soluzione){
      const promo =[];
      soluzione.risorse.forEach(ris =>{
        if(ris.ElencoPromozioni){
          ris.ElencoPromozioni.forEach(p =>{
            promo.push(p);
          })
        }

      })
      return promo //eseguo la distinct...
    },
    modifica(context, variable) {
      this.context = context;
      this.variabile = variable;
      console.log(variable);
      this.dialog = true;
    },
    setvalue() {
      console.log("dialog chiuso");
      this.$store.dispatch("updatePreventivo");
      this.dialog = false;
    },
    composemail(){
      this.admin = true;
      this.composingmail=!this.composingmail
    },
    get_img_piede(indice){
      if(this.preventivo.galleria_piede[indice]){
        return this.preventivo.galleria_piede[indice].src;
      }
    },
    convertidata(data){
      if(data){
        var d = new Date(data),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;

        return [day, month, year].join('-');       
      }

    }
  },
  created() {
    /* axios
      .get(
        "https://us-central1-hrcrm-439b3.cloudfunctions.net/webApi/api/v1/preventivi/86CEEBD2-4A66-4B73-91DD-887D68BEAE1D"
      )
      .then(res => ((this.todos = res.data), console.log("hi", res.data)))
      .catch(err => console.log(err));*/


      
  },
  mounted() {
    this.antprimahr = this.$route.query.k=='hr';
    /*
    axios
      .get(
        "https://us-central1-hrcrm-439b3.cloudfunctions.net/webApi/api/v1/preventivi/277B4311-9922-450A-87CC-57A5447D5AB4"
      )
      .then(res => ((this.proposal = res.data), console.log("hi", res.data)))
      .catch(err => console.log(err));
      */

          Vue.use(VueFbCustomerChat, {
      page_id: this.$store.state.config.facebook_page_id, //  change 'null' to your Facebook Page ID,
      theme_color: "#333333", // theme color in HEX
      locale: "en_US" // default 'en_US'
    });

    Vue.use(Editor);
    this.carica_preventivo(this.idreservation)
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      user: "user"
    }),
    preventivo() {
      return this.$store.state.preventivo;
    },
    is_scaduto(){
      let opz = new  Date(this.preventivo.data_opzione);
      let oggi = new Date();
      console.log("IS_SCADUTO",this.preventivo.data_opzione,opz,oggi)
      return  opz < oggi && this.preventivo.data_opzione != null;
    },
    testi() {
      console.log(
        "testiagg",
        this.$store.state.strutture.data[this.$store.state.strutturacorrente]
          .info
      );
      return this.$store.state.strutture.data[
        this.$store.state.strutturacorrente
      ].info;
    }
  },
  data: () => ({
    antprimahr:false,
    video:false,
    todos: [],
    active_el:'',
    proposal: [],
    //myJson: json,
    key: "1",
    show: "",
    showMessage: true,
    showMessage2: false,
    selected: true,
    isclass: "",
    mail:"",
    piva:"",
    telefono:"",
    logo:null,
    indirizzo:"",
    nomestruttura:"",
    utente_immagine:"",

    composingmail: false,
    testomail: "testo da inviare via mail",
    menu_templates: false,
    dialog: false,
    dialog_conferma:false,
    soluzione_da_confermare:null,
    loading: true,
    testiagg: [],
    fab: false,
    sceglitemplate: false,
    template_to_export: {
      nominativo: null,
      intro: null,
      testoiniziale: null,
      titolo: null,
      sottotitolo: null
    },
    soluzioni:[],
    preventivo:{
      galleria_piede:[{src:''},{src:''},{src:''},{src:''},{src:''},{src:''}]
    },
    tab: null,
    admin: false,
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    icons: false,
    centered: false,
    grow: false,
    vertical: false,
    prevIcon: false,
    nextIcon: false,
    right: false,
    tabs: 3,
    footer_icons: [
      "mdi-facebook",
      "mdi-twitter",
      "mdi-google-plus",
      "mdi-linkedin",
      "mdi-instagram"
    ]
  })
};
// var Tawk_API = Tawk_API || {};
// let Tawk_LoadStart = new Date();
/*
(function() {
  var s1 = document.createElement("script"),
    s0 = document.getElementsByTagName("script")[0];
  s1.async = true;
  s1.src = "https://embed.tawk.to/564f634590d1bced690e0633/default";
  s1.charset = "UTF-8";
  s1.setAttribute("crossorigin", "*");
  s0.parentNode.insertBefore(s1, s0);
})();
*/
</script>


<style>
@import url('https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

  :root{
    --primary-color: #e71010!important; /*bdaa94*/
    --secondary-color: #db9717!important; /*ded9d3*/
    --tertiary-color: #f0a418!important;
    --success-color: #80b855!important;
    --warning-color: #eaca44!important;
    --error-color: #ef4d4d!important;
    --bg-color: #C5C5C5!important;
  }  
  
  @font-face {
  font-family: "Gill Sans Light";
  src: url("../assets/fonts/mgillsans-light.eot");
  src: url("../assets/fonts/mgillsans-light.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/mgillsans-light.woff2")
      format("woff2"),
    url("../assets/fonts/mgillsans-light.ttf")
      format("truetype"),
    url("../assets/fonts/mgillsans-light.otf")
      format("opentype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Gill Sans Light";
  src: url("../assets/fonts/mgillsans-light.eot");
  src: url("../assets/fonts/mgillsans-light.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/mgillsans-light.woff2")
      format("woff2"),
    url("../assets/fonts/mgillsans-light.ttf")
      format("truetype"),
    url("../assets/fonts/mgillsans-light.otf")
      format("opentype");
  font-weight: normal;
  font-style: italic;
}
@font-face {
  font-family: "Gill Sans Light";
  src: url("../assets/fonts/mgillsans-bold.eot");
  src: url("../assets/fonts/mgillsans-bold.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/mgillsans-bold.woff2")
      format("woff2"),
    url("../assets/fonts/mgillsans-bold.ttf")
      format("truetype"),
    url("../assets/fonts/mgillsans-bold.otf")
      format("opentype");
  font-weight: bold;
  font-style: normal;
}
@font-face {
  font-family: "Gill Sans Light";
  src: url("../assets/fonts/mgillsans-bold.eot");
  src: url("../assets/fonts/mgillsans-bold.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/mgillsans-bold.woff2")
      format("woff2"),
    url("../assets/fonts/mgillsans-bold.ttf")
      format("truetype"),
    url("../assets/fonts/mgillsans-bold.otf")
      format("opentype");
  font-weight: bold;
  font-style: italic;
}

body {
  font-family: "Gill Sans Light", sans-serif !important;
  font-size: 16px !important;
  line-height: 22px !important;
  font-weight: 200 !important;

}
.footer-icon {
  position: fixed;
  right: 50px;
  z-index: 1;
  bottom: 30px;
}

.footer-icon a {
  display: inline-block;
  width: 60px;
  height: 60px;
  font-size: 40px;
  background: var(--primary-color);
  text-align: center;
  line-height: 60px;
  border-radius: 100%;
  color: #fff;
}

.footer-icon a:hover {
  opacity: 0.9;
  color: #ccc;
}
div#accordion-1 .text {
  padding: 15px !important;
}

p.card-text img.medium {
  width: 49%;
  margin-bottom: 15px;
}

p.card-text strong {
  display: block;
  margin-bottom: 15px;
}

div#accordion-1 .rooms-feats.mt-3 {
  padding: 15px !important;
  display: table;
}
.paddingbox {
  width: 96%;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
}
.right-icon {
  float: right;
  font-size: 31px;
  margin-top: 0px;
}
.text {
  font-family: "Gill Sans Light", sans-serif !important;
  font-size: 16px !important;
  line-height: 22px !important;
}
ul.iconsocial {
  margin: 0px;
  padding: 0px;
}

ul.iconsocial li {
  display: inline-block;
  list-style: none;
  padding: 5px;
}
.logo img {
  width: 150px;
  border-radius: 5px;
}

/* ul.iconsocial li a {
  font-size: 18px;
  display: block;
  width: 40px;
  height: 40px;
  background: #f0efed;
  border-radius: 100%;
  line-height: 40px;
  color: #000;
  border: 1px solid #ccc;
} */

ul.iconsocial li a:hover {
  background: #f5f5f5;
}

iconsocial .rooms-feats {
  font-family: "Gill Sans Light", sans-serif !important;
}
.contatto {
  color: #000000;
  font-family: "Gill Sans Light", sans-serif;
  font-size: 36px;
  line-height: 42px;
  font-weight: normal;
  padding-top: 61px;
}
p.card-text span {
  background-color: transparent !important;
}
.styles {
  text-align: justify;
  font-family: "Gill Sans Light", sans-serif !important;
}
.style {
  padding: 25px;
  background: #ccc;
  text-align: justify;
  color: grey;
}
.bg-cont {
  background: var(--secondary-color);; /* #f0efed;*/
}
.nostri {
  font-family: "Gill Sans Light", sans-serif;
  font-size: 37px;
  padding-top: 57px;
}
.set {
  text-align: center;
  margin-top: 40px;
  padding-bottom: 56px;
}

.impresss {
  text-align: center;
  background: #ccc;
  font-family: -webkit-pictograph;
}
.contai {
  background: #f0efed;
  padding-top: 70px;
  padding-bottom: 70px;
}
.cont {
  padding-top: 86px;
  padding-bottom: 86px;
}

#accord-heading {
  background: var(--primary-color);
  padding-top: 0px;
  padding-bottom: 0px;
}

#carousel-1 {
  margin-top: -195px;
}
nav.navbar {
  z-index: 99;
  background-color: transparent;
}
#back-color {
  background-color: var(--secondary-color);
  color: #333333;
  padding: 1rem 1rem 0rem;
}

footer.footer .bordertop {
  padding: 15px 15px 0 10px;
}
.border,
.bordertop,
.borderbottom,
.borderright,
div.chat div.messenger ul.messagesOne .arrowborder {
  border-color: #cccccc;
}
.bordertop {
  border-top-width: 1px;
  border-top-style: solid;
}
/* user agent stylesheet div {
  display: block;
}
.bgweb {
  background-color: #ffffff;
  color: #333333;
} */

h1.navbar-brand.mb-0 {
  display: inline-block;
  margin-left: 110px;
  margin-right: 110px;
}
@media (max-width: 992px) {
  .carousel-caption {
    position: relative !important;
    left: 0px !important;
    right: 0px !important;
    bottom: 0px !important;
  }
  .persoal-cc h3 {
    width: 75% !important;
    font-size: 18px !important;
  }

  .persoal-cc h2 {
    font-size: 14px !important;
  }

  .tabsbv ul li {
    font-size: 16px !important;
  }
  h1.navbar-brand.mb-0 {
    margin: auto !important;
  }
  .container-fluid.contai {
    padding-left: 15px !important;
  }
  .cont {
    left: 0px !important;
    margin-bottom: 15px;
  }
  .col-sm-4.bg-cont {
    padding: 15px !important;
  }
  .col-sm-4.bg-cont {
    padding: 15px !important;
  }

  p.card-text span {
    display: block;
  }

  p.card-text ul {
    padding: 0px !important;
    text-align: left !important;
  }
  div#back-color table.table th {
    width: auto !important;
  }
  p.card-text img.medium {
    width: 100%;
  }
  .rooms-feats ul {
    padding-left: 15px !important;
  }
  .container-fluid.cont .col-md-3 {
    width: 50%;
    margin-bottom: 15px;
  }
  .col-md-12.col-md-offset-4.set img {
    width: 85px;
    left: 0px !important;
    margin-right: 10px;
  }
  .col-md-12.col-md-offset-4.set img {
    width: 85px;
    left: 0px !important;
    margin-right: 10px;
  }
}

.perposal-box {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  background: #fff;
  border-radius: 5px;
  overflow: hidden;
}

.perposal-text {
  background: #fff;
  padding: 15px;
}

.text-left h3 {
  font-size: 0.875rem;
}

.perposal-text {
  font-size: 0.875rem;
}

.perposal-text h4 {
  font-size: 0.875rem;
  font-weight: 600;
}
.text-pp {
  position: relative;
}

.perposal-name {
  position: absolute;
  z-index: 1;
  bottom: 15px;
  left: 15px;
  font-size: 30px;
  color: #fff;
}
.sizebox {
  font-size: 24px;
}

.prosoal-pricebox .card-header {
  background: var(--primary-color);
  padding: 0px 10px;
  overflow: hidden;
}

.prosoal-pricebox .card-header a {
  display: block;
  border-radius: 0px;
  font-size: 24px;
  font-weight: bold;
  text-transform: capitalize;
  padding: 15px;
  text-align: center;
  color: #000;
}

.prosoal-pricebox .card-header li {
  width: 50%;
  background: var(--secondary-color);
}

.prosoal-pricebox .card-header ul {
  border: 0px;
}

.prosoal-pricebox .card-header li a {
  background: var(--secondary-color);
}

.prosoal-pricebox .card-header li a.active {
  background: #a8b5bc;
}

.persoal-cc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
  padding-bottom: 10px;
}

.persoal-cc h2 {
  margin: 0px;
  font-weight: 600;
}
.sliderbanner #carousel-1 {
  margin: 0px;
}

.sliderbanner h4 {
  margin: 15px 0px;
  font-size: 14px;
}

.porsoal-new1 {
  text-align: center;
  font-size: 18px;
  margin-top: 2em;
  margin-bottom: 2em;
}
.destailsdd .body-1 {
  padding: 10px;
  font-size: 18px;
}

.destailsdd .headline {
  font-size: 28px;
  margin-top: 15px;
}
.tabsbv ul {
  margin: 0px;
  padding: 15px;
  background: #eeece9;
}

.tabsbv ul li {
  list-style: none;
  width: 50%;
  display: inline-block;
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
  padding: 8px;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}
.tabsbv ul li.active {
  background: var(--primary-color);
  color: #fff;
}
.des-tile h2 {
  font-weight: 600;
  font-size: 18px;
}

.fv {
  font-size: 24px;
  font-weight: bold;
  color: #2fa34b;
}

span.suboo {
  text-decoration: line-through;
  font-size: 15px;
}
.detailsv {
  outline: none;
  border-bottom: 1px solid #ccc;
  padding-bottom: 10px;
  font-weight: bold;
}
.border-box {
  border-bottom: 1px solid #ccc;
}
h2.exrea-service {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}

h2.exrea-service span {
  font-size: 24px;
  font-weight: bold;
  color: #2fa34b;
}
.font-32 {
  font-size: 24px;
}
.destailsdd {
  padding: 0px 18px;
}
.border_new {
  border: 10px solid var(--primary-color);
  background-color:lawngreen;
}
.border_disabled {
  border: 10px solid var(--secondary-color);
}

.testata .carousel-item img {
        height:100vh!important ;
        object-fit: cover;
    }
.imgcover {
        object-fit: cover;
    }
.dettcamera .carousel-item img {
        height:50vh!important ;
         object-fit: cover;
    }
.desccam ul li{
    list-style: circle;
    width: 100%;
    display: list-item;
    font-size: inherit;
    font-weight: inherit;
    text-transform: capitalize;
    padding: 8px;
    text-align: inherit;
    border-radius: 5px;
    cursor: pointer;
}
.desccam ul {
    margin: 0px;
    padding: 15px;
    background: inherit;
}
h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
    font-weight: 300 !important;

}
.testo-barrato{
  text-decoration: line-through;
  font-size:1.3em;
  color:rgb(221, 68, 68);
}
</style>
